import { useTheme } from 'styled-components';

import { SpinningIcon } from '@/components/common/spinning-icon';
import { Button, ButtonVariant } from '@/components/form/button';

import { IImage } from '../../hooks/use-image-upload';

interface IProps {
  images: IImage[];
  onRemove: (image: IImage) => void;
}

const closeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      className="w-3 h-3 stroke-black"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
};

export const ImageUploadPreview: React.FC<IProps> = ({ images, onRemove }) => {
  const theme: any = useTheme();

  return (
    <div
      id="step-image-upload-preview"
      className="flex overflow-x-auto mt-2 gap-2 h-28 scrollbar-thin scrollbar-thumb-rounded-full scrollbar-thumb-gray scrollbar-track-gray-100 pb-4"
    >
      {images.map((image) => (
        <div key={image.id} className="relative flex-shrink-0">
          <div className="flex absolute right-1 top-1">
            <Button
              variant={ButtonVariant.Link}
              classnames="bg-white p-1 rounded-full opacity-60 hover:opacity-100"
              onClick={() => onRemove(image)}
            >
              {closeIcon()}
            </Button>
          </div>

          <img
            src={image.data}
            alt="preview"
            className={`object-cover w-24 h-24 rounded-md`}
          />

          {image.isValidating && (
            <div className="absolute inset-0 flex items-center justify-center backdrop-blur-sm pl-3">
              <SpinningIcon color={`fill-${theme.current}-primary`} />
            </div>
          )}

          {!image.isValidating && !image.isValid && (
            <div className="absolute inset-0 flex items-center justify-center backdrop-blur-sm">
              <div className="bg-gray mx-1 flex flex-col gap-1 rounded-sm py-1 text-[0.7rem] leading-none font-semibold text-center text-red-light">
                <span>Image is not valid for analysis.</span>
                <span className="font-normal text-[0.6rem]">({image.error})</span>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
